/**
 * Reports Service
 * Project CRUD, reports listing, individual reports, and dashboard metrics
 */

import { apiClient } from '../client';
import type { Project, CreateProjectPayload } from '../../../entities/project';
import type {
    Report,
    ReportListResponse,
    DashboardMetrics,
    PaginationParams,
} from '../../../entities/report';

export const reportsService = {
    // ── Projects ────────────────────────────────────────────────────────

    /** Create a new project */
    createProject: (data: CreateProjectPayload) =>
        apiClient.post<Project>('/reports/projects', data),

    /** List the authenticated user's projects */
    getProjects: (params?: PaginationParams) =>
        apiClient.get<Project[]>('/reports/projects', {
            params: params as Record<string, string | number> | undefined,
        }),

    /** Get a single project by ID */
    getProjectById: (projectId: string) =>
        apiClient.get<Project>(`/reports/projects/${projectId}`),

    /** Delete a project */
    deleteProject: (projectId: string) =>
        apiClient.delete(`/reports/projects/${projectId}`),

    // ── Reports ─────────────────────────────────────────────────────────

    /** List reports for a project */
    getProjectReports: (projectId: string, params?: PaginationParams) =>
        apiClient.get<ReportListResponse>(
            `/reports/projects/${projectId}/reports`,
            { params: params as Record<string, string | number> | undefined },
        ),

    /** Get a single report by ID */
    getReportById: (reportId: string) =>
        apiClient.get<Report>(`/reports/${reportId}`),

    // ── Dashboard ───────────────────────────────────────────────────────

    /** Get aggregated dashboard metrics */
    getDashboardMetrics: () =>
        apiClient.get<DashboardMetrics>('/reports/dashboard/metrics'),
};
   